import React, { useState, useRef, useEffect } from 'react';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
import ColorLensOutlinedIcon from '@mui/icons-material/ColorLensOutlined';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import styled from 'styled-components';
import { WrappedFieldProps } from 'redux-form';

const ColorWrapper = styled.div`
  @media (max-width: 425px) {
    bottom: 20px;
    position: absolute;
    right: 0;
  }
`;

type Props = { alwaysDisplayErrors?: boolean } & TextFieldProps & WrappedFieldProps;

const FormColorField: React.FC<Props> = ({
  input = {},
  meta: { touched, error, dirty } = {},
  alwaysDisplayErrors = false,
  ...rest
}) => {
  const [colorMode, setColorMode] = useState(false);
  const textFieldRef = useRef();

  useEffect(() => {
    if (colorMode) {
      if (textFieldRef.current) {
        textFieldRef.current.click();
      }
    }
  }, [colorMode]);

  return (
    <>
      <FormGroup>
        <ColorWrapper>
          <FormControlLabel
            labelPlacement="start"
            style={{ position: 'absolute', right: 0, bottom: '40px', fontSize: '12px' }}
            label=""
            control={
              <Checkbox
                onChange={() => {
                  setColorMode(!colorMode);
                }}
                value={colorMode}
                defaultChecked={colorMode}
                icon={<ColorLensOutlinedIcon />}
                checkedIcon={<ColorLensIcon />}
              />
            }
          />
        </ColorWrapper>
      </FormGroup>
      <TextField
        {...rest}
        {...input}
        onBlur={() => {
          if (colorMode) {
            setColorMode(!colorMode);
          }
        }}
        inputRef={textFieldRef}
        type={colorMode ? 'color' : 'text'}
        style={{ textTransform: 'uppercase' }}
        error={!!((touched || alwaysDisplayErrors) && error)}
      />
      {(dirty || alwaysDisplayErrors) && error && (
        <div>
          <FormLabel error style={{ fontSize: 12, marginTop: 10 }}>
            {error}
          </FormLabel>
        </div>
      )}
    </>
  );
};

export default FormColorField;
